import {makeStyles} from '@material-ui/styles';
import {merge} from 'helpers/styles';

export default makeStyles((theme) => ({
        'root': merge({
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 140,
                background: theme.palette.common.darkBlue,
                [theme.breakpoints.down('sm')]: {
                    height: 'auto',
                },
                '&:before': {
                    position: 'absolute',
                    top: 0,
                    left: `calc(-50vw + (${theme.widthBase}px / 2))`,
                    content: '""',
                    width: '100vw',
                    height: '100%',
                    background: theme.palette.common.darkBlue,
                    [theme.breakpoints.down(1600)]: {
                        left: -50,
                    },
                    [theme.breakpoints.down('md')]: {
                        left: -25,
                    },
                    [theme.breakpoints.down('sm')]: {
                        left: 0,
                    },
                },
            },
            theme.gutter.md.margin.bottom,
        ),
        '__container': {
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center',
                flexWrap: 'wrap',
            },
        },
        '__label': merge({
                position: 'relative',
                zIndex: 5,
                fontFamily: theme.typography.fontFamilyHeadings,
                fontWeight: 600,
                fontStyle: 'italic',
                fontSize: 24,
                color: theme.palette.common.white,
            },
            theme.gutter.sm.margin.right,
        ),
        '__indicator': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
    }),
    {
        name: 'SupportMenu',
    },
);
